var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container-fluid"},[(_vm.isHideSidebar)?_c('div'):_vm._e(),(_vm.isAdmin)?_c('Index'):_vm._e(),(_vm.isDoctor)?_c('Message'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }